export default __webpack_public_path__ + "static/media/Group 2.345aa532.png";